export enum IdentifierCountry {
    NL = 'NL',
    B = 'B',
    DE = 'DE',
}
